import styled from "styled-components/macro";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 1.3rem 1rem 1.3rem;

  @media (min-width: 992px) {
    justify-content: flex-start;
    align-items: start;
    padding: 0;
    height: 55rem;
  }
`;
export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 0 1.5rem 0;
  h1 {
    margin: 0;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 600;
    font-size: 29px;
    line-height: 38px;
    text-align: center;
    margin-bottom: 1rem;
    color: #000000;
    padding: 0 0.3rem;
  }
  p {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    padding: 0 1.5rem;
    text-align: center;
    color: #000000;
  }
  @media (min-width: 992px) {
    justify-content: flex-start;
    align-items: start;
    padding: 5rem 7.7rem 1rem 7.7rem;

    h1 {
      font-size: 40px;
      line-height: 47px;
      text-align: start;
      padding: 0;
    }
    p {
      font-size: 18px;
      line-height: 20px;
      text-align: start;
      padding: 0 35rem 0 0;
    }
  }
`;
export const ContainerInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 20px;
  align-items: start;
  padding: 1rem 0.4rem;
  @media (min-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    align-items: start;
    justify-content: start;
    padding: 1rem 4.6rem 1rem 7.7rem;
  }
`;
export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  padding: 1rem 0.7rem 0 0.6rem;
  margin-bottom: 2rem;

  transform: ${({ scroll, text }) =>
    scroll > 1898 && text === 1
      ? "translateY(0)"
      : scroll > 2000 && text === 2
      ? "translateY(0)"
      : scroll > 2200 && text === 3
      ? "translateY(0)"
      : scroll > 2400 && text === 4
      ? "translateY(0)"
      : scroll > 2600 && text === 5
      ? "translateY(0)"
      : scroll > 2800 && text === 6
      ? "translateY(0)"
      : "translateY(1rem)"};

  opacity: ${({ scroll, text }) =>
    scroll > 1898 && text === 1
      ? "1"
      : scroll > 1898 && text === 2
      ? "1"
      : scroll > 1898 && text === 3
      ? "1"
      : scroll > 1898 && text === 4
      ? "1"
      : scroll > 1898 && text === 5
      ? "1"
      : scroll > 1898 && text === 6
      ? "1"
      : "0"};

  transition: transform 0.5s, opacity 0.6s ease-in-out;
  @media (min-width: 992px) {
    padding: 0 0 2rem 0;
    justify-content: flex-start;
    align-items: start;
    transform: ${({ scroll, text }) =>
      scroll > 0 && text === 1
        ? "translateY(0)"
        : scroll > 1800 && text === 2
        ? "translateY(0)"
        : scroll > 1880 && text === 3
        ? "translateY(0)"
        : scroll > 1880 && text === 4
        ? "translateY(0)"
        : scroll > 1880 && text === 5
        ? "translateY(0)"
        : scroll > 1880 && text === 6
        ? "translateY(0)"
        : "translateY(1rem)"};

    opacity: ${({ scroll, text }) =>
      scroll > 1700 && text === 1
        ? "1"
        : scroll > 1700 && text === 2
        ? "1"
        : scroll > 1880 && text === 3
        ? "1"
        : scroll > 1880 && text === 4
        ? "1"
        : scroll > 1880 && text === 5
        ? "1"
        : scroll > 1880 && text === 6
        ? "1"
        : "0"};

    transition: transform 0.7s, opacity 0.7s ease-in-out;
  }
`;

export const IconContainer = styled.div`
  margin-right: 1rem;
`;
export const ContainerTextIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  h4 {
    margin: 0 0 0.5rem 0;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-align: start;
    color: #000000;
  }
  p {
    margin: 0;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: start;
    color: #000000;
    padding-right: 2rem;
  }
  @media (min-width: 992px) {
    h4 {
      font-size: 16px;
      line-height: 18px;
      padding-bottom: 0.5rem;
    }
    p {
      font-size: 16px;
      line-height: 20px;
      padding-right: 3rem;
    }
  }
`;
export const Svg = styled.svg`
  width: 40px;
  height: 47.48px;
`;
